module.exports = __webpack_public_path__ + "static/media/billing_illustration.00e13f6b.avif";